import { createSlice } from "@reduxjs/toolkit";
import { getProducts, changeActive, getExtras, changeExtraActive, changeSuggested, menuCentralAdmin, disableMenuItemExtraAdmin, menuExtrasAdmin, importItems, disableMenuItemAdmin, getAdminProducts } from "../../api/Products";

export const productsSlice = createSlice({
  name: "products",
  initialState: {
    products: [],
    extras: [],
    categories: [],
    currentBranch: null,
  },
  reducers: {
    setProducts: (state, action) => {
      state.products = action.payload;
    },
    setCategories: (state, action) => {
      state.categories = action.payload;
    },
    setExtras: (state, action) => {
      state.extras = action.payload;
    },
    setActive: (state, action) => {
      const { product, val, platform } = action.payload;
      const index = state.products.findIndex((el) => el.id === product);
      state.products[index][platform] = val;
    },

    setExtraActive: (state, action) => {
      const { extra, val, platform } = action.payload;
      const indexExtra1 = state.extras.extras.findIndex((el) => el.id === extra);
      const indexExtra2 = state.extras.extras2.findIndex((el) => el.id === extra);
      if (indexExtra1 > -1) state.extras.extras[indexExtra1][platform] = val;
      if (indexExtra2 > -1) state.extras.extras2[indexExtra2][platform] = val;

    },

    setSuggested: (state, action) => {
      const { product, val } = action.payload;
      const index = state.products.findIndex((el) => el.id === product);
      state.products[index].suggested = val;
      state.products[index].take_out = val;
    },
    setCurrentBranch: (state, action) => {
      state.currentBranch = action.payload;
    },
  },

});

// Action creators are generated for each case reducer function
export const { setProducts, setActive, setCategories, setExtras, setSuggested, setExtraActive, setCurrentBranch } = productsSlice.actions;

export const getAllProducts = (branch) => async (dispatch) => {
  try {
    const response = await getProducts(branch);
    if (!response.error && response.status === 200) {
      const { categories } = response.data;
      let products = [];
      const productCategories = [];
      categories.forEach((category) => {
        products = products.concat(category.products);
        productCategories.push({ text: category.name, value: category.id });
      });
      dispatch(setProducts(products));
      dispatch(setCategories(productCategories));
      return {
        status: "success",
      };
    }
    return {
      status: "error",
      type: "unkown",
    };
  } catch (e) {
    return {
      status: "error",
      type: "unknown",
    };
  }
};

export const getAllAdminProducts = (branch) => async (dispatch) => {
  try {
    const response = await getAdminProducts(branch);
    if (!response.error && response.status === 200) {
      const { categories } = response.data;
      let products = [];
      const productCategories = [];
      categories.forEach((category) => {
        products = products.concat(category.products);
        productCategories.push({ text: category.name, value: category.id });
      });
      dispatch(setProducts(products));
      dispatch(setCategories(productCategories));
      return {
        status: "success",
      };
    }
    return {
      status: "error",
      type: "unkown",
    };
  } catch (e) {
    return {
      status: "error",
      type: "unknown",
    };
  }
};

export const handleCurrentBranch = (branch) => async (dispatch) => {
  dispatch(setCurrentBranch(branch));
  return branch
};

export const handleActive = (product, active, platform, branch, userId) => async (dispatch) => {
  try {
    dispatch(setActive({ product, val: !active, platform, branch, userId }));
    const response = await changeActive(product, !active, platform, branch, userId);
    if (!response.error && response.status === 200) {
      return {
        status: "success",
      };
    }
    dispatch(setActive({ product, val: active, platform, branch, userId }));
    return {
      status: "error",
      type: "unkown",
    };
  } catch (e) {
    dispatch(setActive({ product, val: active, platform, branch, userId }));
    return {
      status: "error",
      type: "unknown",
    };
  }
};

export const getAllExtras = (branch) => async (dispatch) => {
  try {
    const response = await getExtras(branch);
    if (!response.error && response.status === 200) {
      const { extras, extras2 } = response.data;
      //let extras = [];
      //infxtra.forEach((item) => {
      //  extras.push(item);
      //});
      const new_extras = { extras, extras2 };
      dispatch(setExtras(new_extras));
      return {
        status: "success",
      };
    }
    return {
      status: "error",
      type: "unkown",
    };
  } catch (e) {
    return {
      status: "error",
      type: "unknown",
    };
  }
};

export const handleExtraActive = (extra, active, platform, branch, cat, userId) => async (dispatch) => {
  try {
    dispatch(setExtraActive({ extra, val: !active, platform, branch, cat, userId }));
    const response = await changeExtraActive(extra, !active, platform, branch, cat, userId);
    if (!response.error && response.status === 200) {
      return {
        status: "success",
      };
    }
    dispatch(setExtraActive({ extra, val: active, platform, branch, cat, userId }));
    return {
      status: "error",
      type: "unkown",
    };
  } catch (e) {
    dispatch(setExtraActive({ extra, val: active, platform, branch, cat, userId }));
    return {
      status: "error",
      type: "unknown",
    };
  }
};

export const handleSection = (product, active, platform, branch, userId) => async (dispatch) => {
  try {
    dispatch(setSuggested({ product, val: Number(!active), platform, branch, userId }));
    const response = await changeSuggested(product, Number(!active), platform, branch, userId);
    if (!response.error && response.status === 200) {
      return {
        status: "success",
      };
    }
    dispatch(setSuggested({ product, val: active, platform, branch, userId }));
    return {
      status: "error",
      type: "unkown",
    };
  } catch (e) {
    dispatch(setSuggested({ product, val: active, platform, branch, userId }));
    return {
      status: "error",
      type: "unknown",
    };
  }
};

export const menuCentralAdminThunk = (userId) => async (dispatch) => {
  try {
    const response = await menuCentralAdmin(userId);
    if (!response.error && response.status === 200) {
      const { categories } = response.data;
      let products = [];
      const productCategories = [];
      categories.forEach((category) => {
        products = products.concat(category.products);
        productCategories.push({ text: category.name, value: category.id });
      });
      dispatch(setProducts(products));
      dispatch(setCategories(productCategories));
      return {
        status: "success",
      };
    }
    return {
      status: "error",
      type: "unkown",
    };
  } catch (e) {
    return {
      status: "error",
      type: "unknown",
    };
  }
}
export const menuExtrasAdminThunk = (userId) => async (dispatch) => {
  try {
    const response = await menuExtrasAdmin(userId);
    if (!response.error && response.status === 200) {
      const { extras, extras2 } = response.data;
      //let extras = [];
      //infxtra.forEach((item) => {
      //  extras.push(item);
      //});
      const new_extras = { extras, extras2 };
      dispatch(setExtras(new_extras));
      return {
        status: "success",
      };
    }
    return {
      status: "error",
      type: "unkown",
    };
  } catch (e) {
    return {
      status: "error",
      type: "unknown",
    };
  }
};
export const disableMenuItemAdminThunk = (userId, sku, mode) => async () => {
  try {
    const response = await disableMenuItemAdmin(userId, sku, mode);
    if (!response.error && response.status === 200) {

      return {
        status: "success",
      };
    }
    return {
      status: "error",
      type: "unkown",
    };
  } catch (e) {
    return {
      status: "error",
      type: "unknown",
    };
  }
}

export const disableMenuItemExtraAdminThunk = (userId, sku, mode) => async () => {
  try {
    const response = await disableMenuItemExtraAdmin(userId, sku, mode);
    if (!response.error && response.status === 200) {
      return {
        status: "success",
      };
    }
    return {
      status: "error",
      type: "unkown",
    };
  } catch (e) {
    return {
      status: "error",
      type: "unknown",
    };
  }
}

export const importItemsThunk = () => async () => {
  try {
    const response = await importItems();
    if (!response.error && response.status === 200) {
      return {
        status: "success",
      };
    }
    return {
      status: "error",
      type: "unkown",
    };
  } catch (e) {
    return {
      status: "error",
      type: "unknown",
    };
  }
}

export const selectProducts = (state) => state.products.products;
export const selectCategories = (state) => state.products.categories;
export const selectExtras = (state) => state.products.extras;
export const selectCurrentBranch = (state) => state.products.currentBranch;
export default productsSlice.reducer;
